import { hasMobileUserAgent } from '@carvana/stc-utilities';

import { recordException, startTrackingEvent } from './monitoring';

declare global {
  interface Webkit {
    webkit?: any;
  }
  interface Window extends Webkit {}
}
declare global {
  // Add our handlers to window.webkit.messageHandlers
  interface WebKitMessageHandler {
    authUpdate?: {
      postMessage(_: {}): void;
    };
  }
}

// The object created by Android doesn't actually exist on the window object
// so we need to let Typescript know there is a global around, and we can do that
// by using a namespace. This has been tested and does work on the Android simulator
// This will throw a ReferenceError if you try and access it when it's not present
// I can't find a good way around that currently except for catching and handling the
// ReferenceError
declare namespace AndroidAuth {
  function requestCredentials();
}

const EXCEPTION_SITE = 'utilities/mobileCredentials.ts';
const EVENT_NAME = 'MobileCredentialsUpdated'.toLowerCase();

const requestCredentialsUpdate = () => {
  if (!hasMobileUserAgent()) {
    return Promise.resolve(false);
  }
  const stopEvent = startTrackingEvent('MobileCredentials', 'RetrieveNativeAppToken');
  return new Promise((resolve, reject) => {
    try {
      const listener = evt => {
        if (evt instanceof CustomEvent) {
          window.removeEventListener(EVENT_NAME, listener);
          resolve(true);
        }
      };
      window.addEventListener(EVENT_NAME, listener);
      const authUpdate = window?.webkit?.messageHandlers?.authUpdate;
      if (authUpdate) {
        authUpdate.postMessage({});
        return;
      }
      try {
        AndroidAuth.requestCredentials();
        return;
      } catch (err) {
        // Ignore ReferenceErrors as this means we're not really on Android
        if (err instanceof ReferenceError) {
          return;
        }
        recordException(err, {
          site: EXCEPTION_SITE,
          message: 'Unexpected error while accessing android credentials'
        });
      }
    } catch (err) {
      recordException(err, {
        site: EXCEPTION_SITE,
        message: 'Unexpected error while requesting update of credentials'
      });
    }
    reject();
  }).finally(() => {
    stopEvent();
  });
};

export { requestCredentialsUpdate };
